import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';

export const createMetadataEntry = async (metadata_entry) => {
  return await axios
    .post('manage/metadata_entries', metadata_entry)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const updateMetadataEntry = async (id, title) => {
  return axios
    .put(`manage/metadata_entries/${id}`, { title })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyMetadataEntry = async (id, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`manage/metadata_entries/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};
